import { sample } from "effector"
import { t } from "i18next"
import { notificationsApi } from "@callcenter/api"

import { feedbackApi } from "../api"

sample({
  clock: feedbackApi.submitFeedbackFx.done,
  fn: () => ({ text: t("component_commonKeys_feedbackModal_successNotification") }),
  target: notificationsApi.successNotificationFx
})

sample({
  clock: feedbackApi.submitFeedbackFx.fail,
  fn: () => ({ text: t("component_commonKeys_feedbackModal_errorNotification") }),
  target: notificationsApi.failedNotificationFx
})
